<template>
   <div class="pc-slide" @click.stop="">
	<div class="view">
         <video :src="videoUrl" :autoplay="autoplay" controls></video>
	</div>
	<div class="preview">
		<div class="swiper-container">
			<div class="swiper-wrapper">
				<div class="swiper-slide" v-for="(item, index) in pluginJson" :key="index" @click="viedeoChange(item, index)">
					<img :src="item.video.videoCoverImgUrl" alt="">
          <div v-show="curIndex !== index" class="cover"></div>
          <p>{{item.name}}</p>
				</div>
			</div>
		</div>
	</div>
</div>
</template>

<script>
export default {
  name: 'videoSet',
  props: {
    pluginJson: {
      type: Array,
      default: function () {
        return null
      }
    },
    pluginIndex: {
      type: String
    }
  },
  data () {
    return {
      previewSwiper: null,
      show: true,
      stationJson: [],
      dialogData: [],
      swiperText: '',
      activeIndex: 0,
      autoplay: true,
      videoUrl: '',
      curIndex: 0
    }
  },
  watch: {
  },
  mounted () {
    let index = Number(this.pluginIndex) - 1
    this.curIndex = index
    this.previewSwiper = new window.Swiper('.preview .swiper-container', {
      direction: 'vertical',
      freeMode: true,
      slidesPerView: 'auto',
      mousewheelControl: true,
      onInit: function (swiper) {
        swiper.slideTo(index, 500, false)
      }
    })
    this.$nextTick(() => {
      this.videoUrl = this.pluginJson[index].video.videoIntro
    })
  },
  methods: {
      viedeoChange (item, index) {
        //   切换视频
        this.videoUrl = item.video.videoIntro
        this.curIndex = index
      }
  }
}
</script>

<style lang="scss" scoped>
  @function rem($px) {
    @return $px * (1/40) * 1rem;
  }

 body {
	padding: 0;
	margin: 0;
}

.pc-slide {
	width: rem(1200);
	height: rem(560);
	margin: rem(100) auto;
    display: flex;
  background: #192346;
}

.view  {
	width: rem(1000);
	height: rem(560);

    video {
        width: rem(1000);
	    height: rem(560);
    }
}


.preview {
	width: rem(200);
  /*height: rem(560);*/
	position: relative;
  padding-top: rem(10);
  overflow: hidden;
  box-sizing: border-box;
}

.preview .swiper-container {
	width: rem(200);
    height: rem(560);
}

.preview .swiper-slide {
	width: rem(160);
	height: rem(130);
	cursor:pointer;
    margin-bottom: rem(20);
    align-self: center;
  text-align: left;
  position: relative;

    img {
        width: rem(160);
        height: rem(100);
    }
  .cover{
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    height: rem(100);
    background: rgba(0,0,0,0.4);
  }

    p {
        font-size: rem(14);
        font-weight: 300;
        color: #FFE1BE;
        line-height: rem(20);
    }
}

</style>
